/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

/*import url and gateway methods */
import { getData, putData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { reactSelectStyle } from "Config/Config";

import { useTranslation } from "react-i18next";

const SaveListPopup = ({
  afterSave,
  listId,
  resetListId,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();
  const offcanvasBodyRef = useRef(null);

  const [listTypeOptions, setlistTypeOptions] = useState([]);

  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [listTypeValue, setlistTypeValue] = useState(null);
  const [listType, setlistType] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [companyList, setcompanyList] = useState([]);
  const [contactList, setcontactList] = useState([]);

  /* hook for validation */
  const [errors, setErrors] = useState({});

  const getAllListType = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GET_LIST_TYPE + `?token=${token}`;

      const response = await getData(requestURL);
      // console.log(response);

      if (response.status) {
        setlistTypeOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
      setlistTypeOptions([]);
    }
  };

  const typeSelectionHandler = (val) => {
    setlistTypeValue(val);
    setlistType(val.value);
  };

  //get details of list
  const getDetailsOfList = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_LIST_DETAILS + `/${listId}?token=${token}`;
      const response = await getData(requestURL);

      if (response.status) {
        settitle(response.data.title);
        setdetails(response.data.details);
        setcompanyList(response.data.companyids);
        setcontactList(response.data.contactids);
        typeSelectionHandler(response.data.listtypedata);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //validation
  const validateForm = () => {
    const newErrors = {};
    if (!title.trim()) {
      newErrors.title = t("Please enter a descriptive title for your list.");
    }
    if (listType == null) {
      newErrors.listType = t(
        "Please select a type from the available options for your list."
      );
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //save function
  const saveListHandler = async () => {
    if (!validateForm()) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }
    try {
      setIsSaving(true);

      let listData = {
        title,
        details,
        listtype: listType,
      };

      let requestURL = url.API_BASE_URL;

      let response = {};

      if (listId) {
        requestURL += url.API_UPDATE_A_LIST + `/${listId}?token=${token}`;
        response = await putData(requestURL, listData);
      } else {
        requestURL += url.API_CREATE_LIST + `?token=${token}`;
        response = await postData(requestURL, listData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        resetHandler();
        afterSave([response.data]);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);

      window.bootstrap.Offcanvas.getInstance(
        document.querySelector("#offcanvasSaveList")
      ).hide();
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  const resetHandler = () => {
    settitle("");
    setdetails("");
    setlistTypeValue(null);
    setlistType(null);
    setErrors({});
    resetListId();
  };

  useEffect(() => {
    if (listId) {
      getDetailsOfList();
    }
  }, [listId]);

  useEffect(() => {
    getAllListType();
  }, []);

  // Custom styles for react-select to show validation error
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.listType ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.listType ? "#dc3545" : "#ced4da",
      },
      boxShadow: "0 !important",
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
    }),
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasSaveList"
      aria-labelledby="offcanvasUpdateListLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              list
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasUpdateListLabel"
            >
              {listId ? t("Edit List") : t("Add or Update Lists")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {listId
                ? t("Manage existing list details")
                : t("Define a new list")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4" ref={offcanvasBodyRef}>
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="title"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="title"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., My Marketing Leads List")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title}</div>
                )}
              </div>
              {/* details */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="description"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Description")}
                </label>
                <textarea
                  name="description"
                  id="description"
                  cols="30"
                  rows="3"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t(
                    "Provide a brief description for your list (optional)"
                  )}
                  value={details}
                  onChange={(e) => setdetails(e.target.value)}
                ></textarea>
              </div>
              {/* select type */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="typeOfList"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Select List Type")} <span className="text-danger">*</span>
                </label>
                <Select
                  placeholder={t(
                    "Choose a list type for your list (e.g., Leads, Contacts, Company)"
                  )}
                  options={listTypeOptions}
                  value={listTypeValue}
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  onChange={(val) => {
                    typeSelectionHandler(val);
                    if (errors.listType) {
                      setErrors((prev) => ({ ...prev, listType: "" }));
                    }
                  }}
                />
                {errors.listType && (
                  <div className="invalid-feedback d-block">
                    {errors.listType}
                  </div>
                )}
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                disabled={isSaving ? true : false}
                onClick={saveListHandler}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save List")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default SaveListPopup;
